import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaAuthGuard } from '@okta/okta-angular';
import { LogoutGuard } from '../shared/guards/logout/logout.guard';
import { UserGuard } from '../shared/guards/user/userGuard';
import { RoutesKeys } from '../utils/routes';
import { AccountSettingsPage } from './account-settings/account-settings.page';
import { BusinessListPage } from './business-list-page/business-list-page';
import { CustomerDetailPage } from './customer-detail/customer-detail.page';
import { FramedPage } from './framed-page.component';
import { HomePage } from './home/home.page';
import { LogoutPage } from './logout/logout.page';
import { OnboardingPage } from './onboarding/onboarding.page';
import { RewardsPage } from './rewards/rewards.page';
import { UploadMigrationPage } from './upload-migration/upload-migration.page';
import { ControlPanelPage } from '../control-panel/pages/control-panel/control-panel.page';
import { Roles } from '../utils/roles';
import { DownloadReportsPage } from './download-reports/download-reports.page';
import { AddEditProductPage } from './add-edit-product/add-edit-product.page';
import { AddEditRewardPage } from './add-edit-reward/add-edit-reward.page';
import { VipSettingsPage } from './vip-settings/vip-settings-page.component';
import { SystemSettingsPage } from './system-settings/system-settings.page';
import { BusinessUnificationPage } from './business-unification/business-unification.page';

const routes: Routes = [
  {
    path: RoutesKeys.LOGOUT,
    component: LogoutPage,
    canActivate: [LogoutGuard],
  },
  {
    path: RoutesKeys.ONBOARDING,
    component: OnboardingPage,
    canActivate: [OktaAuthGuard, UserGuard],
  },
  {
    path: '',
    component: FramedPage,
    canActivate: [OktaAuthGuard, UserGuard],
    canActivateChild: [OktaAuthGuard, UserGuard],
    children: [
      {
        path: RoutesKeys.HOME,
        component: HomePage,
      },
      {
        path: RoutesKeys.ACCOUNT_SETTINGS,
        component: AccountSettingsPage,
      },
      {
        path: RoutesKeys.SYSTEM_SETTINGS,
        component: SystemSettingsPage,
        data: { roles: [Roles.GLOBAL_ADMIN] },
      },
      {
        path: RoutesKeys.BUSINESS_UNIFICATION,
        component: BusinessUnificationPage,
        data: { roles: [Roles.GLOBAL_ADMIN, Roles.REGIONAL_ADMIN] },
      },
      {
        path: RoutesKeys.BUSINESS_LIST,
        component: BusinessListPage,
      },
      {
        path: RoutesKeys.UPLOAD,
        component: UploadMigrationPage,
        canActivate: [],
        data: { roles: [Roles.GLOBAL_ADMIN, Roles.REGIONAL_ADMIN] },
      },
      {
        path: RoutesKeys.CUSTOMER_DETAIL + '/:id',
        component: CustomerDetailPage,
      },
      {
        path:
          RoutesKeys.CUSTOMER_DETAIL +
          '/:id/' +
          RoutesKeys.COUPONS_VIP +
          '/:couponId',
        component: CustomerDetailPage,
      },
      {
        path: RoutesKeys.REWARDS,
        component: RewardsPage,
      },
      {
        path: RoutesKeys.CONTROL_PANEL,
        component: ControlPanelPage,
        canLoad: [OktaAuthGuard, UserGuard],
        data: { roles: [Roles.GLOBAL_ADMIN] },
        loadChildren: () =>
          import('../control-panel/control-panel.module').then(
            (m) => m.ControlPanelModule
          ),
      },
      {
        path: RoutesKeys.DOWNLOAD_REPORTS,
        component: DownloadReportsPage,
        data: { roles: [Roles.GLOBAL_ADMIN, Roles.REGIONAL_ADMIN] },
      },
      {
        path: RoutesKeys.PRODUCT_DETAIL,
        component: AddEditProductPage,
        data: { roles: [Roles.GLOBAL_ADMIN] },
      },
      {
        path: `${RoutesKeys.PRODUCT_DETAIL}/:id`,
        component: AddEditProductPage,
        data: { roles: [Roles.GLOBAL_ADMIN] },
      },
      // TODO edit so that regional admins can also access it.
      // Update expected when implementing direct reward page access
      {
        path: RoutesKeys.REWARD_DETAIL,
        component: AddEditRewardPage,
        data: { roles: [Roles.GLOBAL_ADMIN] },
      },
      {
        path: `${RoutesKeys.REWARD_DETAIL}/:id`,
        component: AddEditRewardPage,
        data: { roles: [Roles.GLOBAL_ADMIN] },
      },
      {
        path: `${RoutesKeys.VIP_SETTINGS_DETAIL}/:id`,
        component: VipSettingsPage,
        data: { roles: [Roles.GLOBAL_ADMIN] },
      },
      { path: '', redirectTo: RoutesKeys.HOME, pathMatch: 'full' },
      { path: '**', redirectTo: RoutesKeys.HOME },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
/**
 * Pages routing module
 */
export class PagesRoutingModule {}
